<template>
  <div class="ticket-add-info" v-if="!reserve">
    <table class="ticket-add-info-table">
      <tbody>
        <tr>
          <td colSpan="2" class="ticket-addon-header">
            {{$t('boarding.footer.header')}}
          </td>
        </tr>
        <tr>
          <td class="ticket-add-info-table-column">
            <ol>
              <li>{{$t('boarding.footer.info1')}}</li>
              <li>{{$t('boarding.footer.info2')}}</li>
              <li>{{$t('boarding.footer.info3')}}</li>
              <li>{{$t('boarding.footer.info4')}}</li>
            </ol>
          </td>
          <td class="ticket-add-info-table-column">
            <ol start="5">
              <li>{{$t('boarding.footer.info5')}}</li>
              <li>{{$t('boarding.footer.info6')}}</li>
              <li>{{$t('boarding.footer.info7')}}</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td class="ticket-addon-header">
            <span v-if="isRetCond">{{$t('boarding.footer.info8')}}</span>
          </td>
          <td class="ticket-addon-header">
            <span v-if="isLuggCond">{{$t('boarding.footer.info9')}}</span>
          </td>
        </tr>
        <tr>
          <td class="ticket-add-info-table-column">
            <ul v-if="isRetCond">
              <li
                v-for="(item, index) in retCond"
                :key="index"
              >{{item}}
              </li>
            </ul>
          </td>
          <td class="ticket-add-info-table-column">
            <ul v-if="isLuggCond">
              <li
                v-for="(item, index) in luggCond"
                :key="index"
              >{{item}}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ticket-add-info" v-else>
    <table class="ticket-add-info-table">
      <tbody>
        <tr>
          <td class="ticket-addon-header">
            <span>{{$t('boarding.footer.important1')}}</span>
          </td>
          <td class="ticket-addon-header">
            <span v-if="isLuggCond">{{$t('boarding.footer.info9')}}</span>
          </td>
        </tr>
        <tr>
          <td class="ticket-add-info-table-column">
            <ul>
              <li>{{$t('boarding.footer.important2')}}</li>
              <li>{{$t('boarding.footer.important3')}}</li>
              <li>{{$t('boarding.footer.important4')}}</li>
            </ul>
          </td>
          <td class="ticket-add-info-table-column">
            <ul v-if="isLuggCond">
              <li
                v-for="(item, index) in luggCond"
                :key="index"
              >{{item}}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BoardingFooter',
  props: {
    retCond: {
      type: Array,
    },
    luggCond: {
      type: Array,
    },
    reserve: {},
  },
  computed: {
    isRetCond() {
      return this.retCond && this.retCond.length;
    },
    isLuggCond() {
      return this.luggCond && this.luggCond.length;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BoardingTicket/BoardingFooter.vue